<label id="question-radio-group-label" class="fst-italic pb-2">
    {{question.label}}
</label>
<div class="py-2 ps-5 pe-2">
    <div class="fs-6 text-secondary">
        @for (choice of possibleAnswers; track choice) {
            <label for="answer-{{choice.id}}" class="answer-option py-2" [ngClass]="{'isChecked': userAnswerId === choice.id}">
                <input id="answer-{{choice.id}}" [value]='choice.id'
                       type="radio" name="answer"
                       [ngModel]="userAnswerId"
                       (ngModelChange)="changeAnswer($event)">
                <div class="custom-checkmark"></div>
                <div class="answer-text-label ps-1">{{choice.label}}</div>
            </label>
        }
    </div>
</div>